import { render, staticRenderFns } from "./EstimateProductItem.vue?vue&type=template&id=5b1df428&scoped=true&"
import script from "./EstimateProductItem.vue?vue&type=script&lang=js&"
export * from "./EstimateProductItem.vue?vue&type=script&lang=js&"
import style0 from "./EstimateProductItem.vue?vue&type=style&index=0&id=5b1df428&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1df428",
  null
  
)

export default component.exports